export const dropFileZoneTheme = {
  bg: 'palette.surface.4',
  iconColor: 'palette.tertiary.40',
};
